import { globalVariables } from "helper/globalVariables";
import {
  barChart,
  clock,
  currencyDollar,
  hammer,
  calendar,
  link,
  star,
} from "helper/icons";
import { filterUniqueLevels } from "helper/utils";

export const TrailSubDetail = ({
  name,
  time,
  level,
  fees,
  dogName,
  openDate,
  closeDate,
  cutoffDate,
  premium,
  trialFile,
  noPremium,
}) => {
  // console.log("level", level?.map((search) => search?.level)?.join(", "));
  return (
    <>
      <p className="text-gray-900 font-sans text-xl font-semibold leading-7">
        {globalVariables.trialDetail}
      </p>
      <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] h-auto md:w-[300px]">
        <img src={hammer} alt="" />
        Judge: {name}
      </p>
      <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] h-auto md:w-[300px]">
        <img src={barChart} alt="" />
        Levels:{" "}
        {filterUniqueLevels(level)
          ?.map((search) => search?.level)
          ?.join(", ")}
      </p>
      {/* <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6">
        <img src={clock} alt="" />
        Time: {time}
      </p> */}
      {/* <p className="h-6 gap-1 flex text-gray-700 font-sans text-[16px] font-[500] leading-6"> */}
      {filterUniqueLevels(level)?.map((search) => {
        return (
          <p className="h-6 gap-1 flex md:w-[500px] text-gray-700 font-sans  font-medium  text-sm md:text-base ">
            <img src={currencyDollar} alt="" />
            {`${search?.level}  Entry Fees: $${search?.entryFee}`}
            <span className="text-[#98A2B3] font-sans text-[16px] font-[500] leading-6">
              ({dogName})
            </span>
          </p>
        );
      })}
      {/* </p> */}
      <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6">
        <img src={calendar} alt="" />
        Open Date: {openDate}
      </p>
      <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6">
        <img src={calendar} alt="" />
        Close Date: {closeDate}
      </p>
      {cutoffDate && (
        <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6">
          <img src={calendar} alt="" />
          Cutoff Date: {cutoffDate}
        </p>
      )}
      {trialFile ? (
        <a
          href={trialFile}
          className="cursor-pointer"
          target="_blank"
          rel="noreferrer"
        >
          <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6">
            <img src={star} alt="" /> {premium}
          </p>
        </a>
      ) : (
        <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6">
          <img src={star} alt="" /> {noPremium}
        </p>
      )}
    </>
  );
};
